import React, {useReducer, useState} from 'react';
import {TableCell, TableRow} from "@material-ui/core";
import AnnualReportStatus, {annualReportStatusTr} from "../../report/constants/AnnualReportStatus";
import WorkableIconExpandButton from "components/button/WorkableIconExpandButton";
import Tr from "translations/Translations"
import moment from "libs/moment";
import RouterPath from "libs/RouterPath";
import DateFormats from "constants/DateFormats";
import WorkableIconPreviewButton from "components/button/WorkableIconPreviewButton";
import AnnualReportsService from "services/AnnualReportsService";
import SimpleTable from "components/complex/simpleTable/SimpleTable";
import AddBoxIcon from '@material-ui/icons/AddBox';
import WorkableIconButton from "components/button/WorkableIconButton";
import iconWorksReducer from "libs/iconWorksReducer";
import {simpleConfirm} from "libs/ConfirmNotification";
import useEzamowieniaOauth from "hooks/useEzamowieniaOauth";
import useSnackbar from "hooks/useSnackbar";
import {MMiA_REQUIRED_GROUPS} from "constants/EzamowieniaRequiredGroups";

function AnnualReportListTableRow(
    {
        report,
        parentWorking,
        classes,
        hasEdit,
    }) {

    const [expanded, setExpanded] = useState(false);
    const {authorizeEzamowienia} = useEzamowieniaOauth();
    const {enqueueSuccessSnackbar} = useSnackbar();
    const [buttonWorks, dispatchButtonWorks] = useReducer(iconWorksReducer, {
        anyWorks: false,
        correct: false,
        loading: false,
    });
    const [prevVersions, setPrevVersions] = useState(null);

    const goToReport = (x) => {
        const href = RouterPath.createPath(RouterPath.annualReport.MP_ANNUAL_REPORT_REPORT_ID, {id: x.identity});
        RouterPath.redirect(href);
    }

    const loadReports = () => {
        if (expanded) {
            setExpanded(false);
        } else if (prevVersions) {
            setExpanded(true);
        } else {
            dispatchButtonWorks({type: 'loading', works: true});
            AnnualReportsService.getAnnualReportPrevVersions(report.identity).then(resp => {
                if (resp) {
                    setPrevVersions(resp);
                    setExpanded(true);
                }
            }).finally(() => dispatchButtonWorks({type: 'loading', works: false}))
        }
    }

    const correctReport = () => {
        dispatchButtonWorks({type: 'correct', works: true});
        simpleConfirm("annual_report_correct_confirm", () => {
            authorizeEzamowienia(
                () => {
                    AnnualReportsService.correctAnnualReportToEzamowienia(report.identity, report.year)
                        .then((resp) => {
                            if (resp && resp.success) {
                                enqueueSuccessSnackbar(Tr("annual_report_correct_success"));
                            }
                        })
                        .finally(() => dispatchButtonWorks({
                            type: 'correct',
                            works: false
                        }))
                },
                () => dispatchButtonWorks({type: 'correct', works: false}),
                MMiA_REQUIRED_GROUPS)
        }, () => dispatchButtonWorks({type: 'correct', works: false}))
    }

    return <>
        <TableRow>
            <TableCell>{report.organization.name}</TableCell>
            <TableCell>{report.ezamowieniaNumber}</TableCell>
            <TableCell>{report.version}</TableCell>
            <TableCell>{moment(report.dateInserted).format(DateFormats.DATETIME_FORMAT)}</TableCell>
            <TableCell>{report.dateModified ? moment(report.dateModified).format(DateFormats.DATETIME_FORMAT) : null}</TableCell>
            <TableCell>{report.dateSend ? moment(report.dateSend).format(DateFormats.DATETIME_FORMAT) : null}</TableCell>
            <TableCell>{annualReportStatusTr(report.status)}</TableCell>
            <TableCell className={classes.buttonColumn}>
                {report.status === AnnualReportStatus.APPROVED &&
                    <WorkableIconButton
                        Icon={AddBoxIcon}
                        tooltip={Tr("annual_report_correct")}
                        onClick={correctReport}
                        working={buttonWorks.correct}
                        disabled={parentWorking || !hasEdit || buttonWorks.anyWorks}
                    />
                }
            </TableCell>
            <TableCell className={classes.buttonColumn}>
                <WorkableIconPreviewButton
                    disabled={parentWorking || buttonWorks.anyWorks}
                    tooltip={Tr("details")} onClick={() => goToReport(report)}
                />
            </TableCell>
            <TableCell className={classes.buttonColumn}><WorkableIconExpandButton
                working={buttonWorks.loading}
                expanded={expanded}
                disabled={parentWorking || buttonWorks.anyWorks || report.version === 1}
                onClick={loadReports}
                tooltip={Tr(expanded ? "collapse_prev_versions" : "expand_prev_versions")}
            /></TableCell>
        </TableRow>

        {
            expanded && !!prevVersions && <TableRow><TableCell className={classes.versionsCell} colSpan={10}>
                <SimpleTable
                    className={classes.versionsTable}
                    headers={[
                        Tr("organizational_unit"),
                        Tr("number_of_processing"),
                        Tr("version"),
                        Tr("add_data"),
                        Tr("modyfication_date"),
                        Tr("transfer_date"),
                        Tr("status"),
                        ''
                    ]}
                    items={
                        prevVersions.map((x, i) => {
                            return [
                                x.organization.name,
                                x.ezamowieniaNumber,
                                x.version,
                                moment(x.dateInserted).format(DateFormats.DATETIME_FORMAT),
                                x.dateModified ? moment(x.dateModified).format(DateFormats.DATETIME_FORMAT) : null,
                                x.dateSend ? moment(x.dateSend).format(DateFormats.DATETIME_FORMAT) : null,
                                annualReportStatusTr(x.status),
                                <WorkableIconPreviewButton disabled={parentWorking || buttonWorks.anyWorks} tooltip={Tr('details')} onClick={() => goToReport(x)}/>
                            ]
                        })
                    }
                    columnClasses={
                        [
                            classes.orgColumn,
                            classes.numberColumn,
                            classes.versionColumn,
                            classes.dateTimeColumn,
                            classes.dateTimeColumn,
                            classes.dateTimeColumn,
                            classes.statusColumn,
                            classes.buttonColumn,
                        ]
                    }
                />
            </TableCell></TableRow>

        }
    </>


}

AnnualReportListTableRow.propTypes = {}

export default AnnualReportListTableRow;